import React from 'react'
import { Button} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import {VERSION} from './../../url/index';
import './../CSS/form.css';
import './../../App.css'


export default function HomePage(props) {
    const navigate = useNavigate();
    const handleClick = (id) => {
        navigate(`/register/${id}`);
    }

    const handleScholarship = () => {
      navigate(`/scholarship`);
    }

    const handleSchool = (id) => {
      navigate(`/school/${id}`);
    }
    const handleNursing = () => {
      navigate(`/nursing`);
    }
  
  return (
    <div>
 <div className='title'>
    <label>Welcome To CTG Group Of Institutions</label>
  </div>

<div className='AppHome' >
<div className="button-container">
  
    <div className="button-section-left">
      <ButtonSection onClick={() => handleClick(1)} text="Click Here to Register for +2 Course" />
      <ButtonSection onClick={() => handleClick(2)} text="Click Here to Register for +3 Course" />
      <ButtonSection onClick={handleScholarship} text="Click Here to Register for Scholarship Programme" />
      <ButtonSection onClick={handleNursing} text="Click Here to Register for Nursing Programme" />
    </div>

    <div className="button-section-right">
      <ButtonSection onClick={() => handleSchool(1)} text="Click Here to Register for CTG Global School (Eng. Medium)" />
      <ButtonSection onClick={() => handleSchool(2)} text="Click Here to Register for CTG Vidya Mandir (Odia Medium)" />
      <ButtonSection onClick={() => handleClick(3)} text="Click Here to Register for MBA/MCA/BBA/BCA/MFC/MSW/B.LIB Course"/>
    </div>
  </div>
</div>


  

  <label className="bottomright">{VERSION}</label>
</div>
  )
}

const ButtonSection = ({ onClick, text }) => (
  <p>
    <Button className="btn btn-light" style={{ width: "80%" }} onClick={onClick}>
      <b style={{ color: "green" }}>{text}</b>
    </Button>
  </p>
);
